import homer from "@homer.api/homer";
import scheduler from "@homer.core/scheduler";
import StorageLocal from "@homer.core/storage.local";
import application from "@homer.core/application";
import unifold from "@unifold/core";
import dy from "@apfelkiste/dy";
import { name } from "../package.json";

const bus = homer.Client.bus;
const client = new homer.Client("/api");
const storageLocal = new StorageLocal(name, { version: application.version });
const current = {};

const processState = (base) => {
    try {
        base = base || JSON.parse(storageLocal.get() || "null") || current;

        // cookie will always overrule localStorage if it exists
        return Object.assign(current, base, {
            dynamicyield: {
                id: dy.id || base?.dynamicyield?.id || current.dynamicyield?.id || null,
                session: dy.session || base?.dynamicyield?.session || current.dynamicyield?.session || null,
            },
        });
    } catch (error) {}

    return current;
};

processState();

storageLocal
    // persist current as it might have changed
    .set(JSON.stringify(current))
    // register listener to handle external changes
    .on("change", () => {
        processState();
    });

bus.on("response", () => {
    // Refresh cookies without replacing retrieved state with stale or unavailable localStorage.
    processState(current);
});

const whenSink = scheduler.yield.low().then(() => {
    return new Promise((resolve) => {
        client
            .post("/sink/retrieve", current, homer.Request.flag.prioritize | homer.Request.flag.suppressEvents)
            .then((data) => {
                // The API response is authoritative even when browser persistence is unavailable.
                processState(data);
                storageLocal.set(JSON.stringify(current));
            })
            .catch((cause) => {
                // Preserve the original exception and transport details for Sentry diagnostics.
                const error = new globalThis.CustomError(
                    "external",
                    { text: `[${name}] Could not load /api/sink/retrieve` },
                    undefined,
                    { ...cause?.data },
                );
                error.cause = cause;
                throw error;
            })
            .finally(() => {
                resolve(current);

                new unifold.Event("sink/retrieved", current).dispatch();
            });
    });
});

export default whenSink;
